/** Fallback MCP permissions when a provider has none configured. */
export const DEFAULT_MCP_PERMISSIONS = {
  include: ["CORE:*", "EDGE:*"],
  exclude: [] as string[],
};
